@if ((loading$ | async) === false) {
  @if (form$ | async; as formState) {
    <div
      class="room-form-shell"
      [class.room-form-shell--has-footer]="formState.canWrite">
      <div class="room-form-panel p-fluid">
      <section class="room-form-section">
        <div class="room-form-section__heading-row">
          <h3 class="room-form-section__title">Основные данные</h3>
          <span class="room-form-section__title-rule-host" aria-hidden="true">
            <span class="room-form-section__title-rule"></span>
          </span>
        </div>

        <div class="field">
          <label class="font-medium required-field">Название</label>
          <crm-input-text
            [(value)]="room.name"
            [isError]="$any(errors?.name)"></crm-input-text>
          @if (errors?.name) {
            <small class="p-error">
              {{ errors.name | join }}
            </small>
          }
        </div>

        <div class="grid">
          <div class="col-12 md:col-4 field">
            <label class="font-medium">Филиал</label>
            <crm-filial-single-select
              [(selectedFilial)]="room.filial"
              [isError]="$any(errors?.filial)"
              [showClear]="true"
              appendTo="body"></crm-filial-single-select>
            @if (errors?.filial) {
              <small class="p-error">
                {{ errors.filial | join }}
              </small>
            }
          </div>
          <div class="col-12 md:col-4 field">
            <label class="font-medium">Этаж</label>
            <p-inputNumber
              [(ngModel)]="room.floor"
              [ngClass]="{ 'ng-invalid ng-dirty': errors?.floor }"
              class="w-full"
              styleClass="w-full">
            </p-inputNumber>
            @if (errors?.floor) {
              <small class="p-error">
                {{ errors.floor | join }}
              </small>
            }
          </div>
          <div class="col-12 md:col-4 field">
            <label class="font-medium">Тип</label>
            <p-dropdown
              [options]="roomTypeOptions"
              [(ngModel)]="room.type"
              optionLabel="label"
              optionValue="value"
              [showClear]="true"
              appendTo="body"
              class="w-full"
              styleClass="w-full">
            </p-dropdown>
            @if (errors?.type) {
              <small class="p-error">
                {{ errors.type | join }}
              </small>
            }
          </div>
        </div>

        <div class="grid">
          <div class="col-12 md:col-6 field">
            <label class="font-medium">Площадь</label>
            <p-inputNumber
              [(ngModel)]="room.square"
              [ngClass]="{ 'ng-invalid ng-dirty': errors?.square }"
              [minFractionDigits]="2"
              class="w-full"
              styleClass="w-full"
              suffix=" м²">
            </p-inputNumber>
            @if (errors?.square) {
              <small class="p-error">
                {{ errors.square | join }}
              </small>
            }
          </div>
          @if (globalService.isEnableModule('PHYSICAL_ACCESS_CONTROL')) {
            <div class="col-12 md:col-6 field">
              <label class="font-medium">Кол-во парковочных мест</label>
              <p-inputNumber
                [(ngModel)]="room.parkingPlacesCount"
                [ngClass]="{ 'ng-invalid ng-dirty': errors?.parkingPlacesCount }"
                [min]="0"
                [minFractionDigits]="0"
                [maxFractionDigits]="0"
                class="w-full"
                styleClass="w-full">
              </p-inputNumber>
              @if (errors?.parkingPlacesCount) {
                <small class="p-error">
                  {{ errors.parkingPlacesCount | join }}
                </small>
              }
            </div>
          }
          <div class="col-12 md:col-6 field">
            <label class="font-medium">Состояние отделки</label>
            <crm-input-text
              [(value)]="room.finishCondition"
              [isError]="$any(errors?.finishCondition)"></crm-input-text>
            @if (errors?.finishCondition) {
              <small class="p-error">
                {{ errors.finishCondition | join }}
              </small>
            }
          </div>
        </div>
      </section>

      <section class="room-form-section">
        <div class="room-form-section__heading-row">
          <h3 class="room-form-section__title">
            Статус
            <span class="room-form-section__required-star">*</span>
          </h3>
          <span class="room-form-section__title-rule-host" aria-hidden="true">
            <span class="room-form-section__title-rule"></span>
          </span>
        </div>
        <div class="room-form-status-grid">
          @for (choice of roomStatusChoices; track choice.value) {
            <button
              type="button"
              class="room-form-status-card"
              [class.room-form-status-card--rented]="room.status === choice.value && choice.value === roomStatusEnum.RENTED"
              [class.room-form-status-card--free]="room.status === choice.value && choice.value === roomStatusEnum.FREE"
              [class.room-form-status-card--reserve]="room.status === choice.value && choice.value === roomStatusEnum.RESERVE"
              [class.room-form-status-card--on-repair]="room.status === choice.value && choice.value === roomStatusEnum.ON_REPAIR"
              (click)="selectRoomStatus(choice.value)">
              <span
                class="room-form-status-card__dot"
                aria-hidden="true"></span>
              <span class="room-form-status-card__label">{{ choice.label }}</span>
            </button>
          }
        </div>
        @if (errors?.status) {
          <small class="p-error block mt-2">
            {{ errors.status | join }}
          </small>
        }
      </section>

      <section class="room-form-section">
        <div class="room-form-section__heading-row">
          <h3 class="room-form-section__title">Связи</h3>
          <span class="room-form-section__title-rule-host" aria-hidden="true">
            <span class="room-form-section__title-rule"></span>
          </span>
        </div>

        @if (globalService.isEnableModule('PHYSICAL_ACCESS_CONTROL')) {
          <div class="field">
            <label class="font-medium">Оборудование</label>
            <crm-converter-multi-select
              [(selectedConverters)]="room.converters"
              [isError]="$any(errors?.converters)"
              [isFloatLabel]="false"
              placeholder="Выбрать или ввести..."
              appendTo="body"></crm-converter-multi-select>
            @if (errors?.converters) {
              <small class="p-error">
                {{ errors.converters | join }}
              </small>
            }
          </div>

          <div class="field">
            <label class="font-medium">Оборудование "NetPing"</label>
            <crm-net-ping-device-multi-select
              [(selectedNetPingDevices)]="room.netPingDevices"
              [isError]="$any(errors?.netPingDevices)"
              placeholder="Выбрать или ввести..."
              appendTo="body"></crm-net-ping-device-multi-select>
            @if (errors?.netPingDevices) {
              <small class="p-error">
                {{ errors.netPingDevices | join }}
              </small>
            }
          </div>
        }

        <div class="grid">
          <div class="col-12 md:col-6 field">
            <label class="font-medium">Клиент</label>
            <crm-client-auto-complete
              [(selectedClient)]="room.client"
              [isError]="$any(errors?.client)"
              [customSearch]="false"
              appendTo="body"></crm-client-auto-complete>
            @if (errors?.client) {
              <p class="p-error m-0">
                {{ errors.client | join }}
              </p>
            }
          </div>
          <div class="col-12 md:col-6 field">
            <label class="font-medium">Пользователи</label>
            <crm-user-multi-select
              [(selectedUsers)]="room.allowUsers"
              [isError]="$any(errors?.allowUsers)"
              [isFloatLabel]="false"
              placeholder="Добавить пользователя..."
              appendTo="body"></crm-user-multi-select>
            @if (errors?.allowUsers) {
              <p class="p-error m-0">
                {{ errors.allowUsers | join }}
              </p>
            }
          </div>
        </div>
      </section>

      <section class="room-form-section">
        <div class="room-form-section__heading-row">
          <h3 class="room-form-section__title">Планы и схемы</h3>
          <span class="room-form-section__title-rule-host" aria-hidden="true">
            <span class="room-form-section__title-rule"></span>
          </span>
        </div>
        <div class="grid room-form-plans-grid">
          <div class="col-12 md:col-6 field room-form-plans-grid__cell">
            <label class="font-medium">План помещения</label>
            @if (room.roomPlan) {
              <div class="flex align-items-center gap-2 flex-wrap">
                <crm-file
                  [file]="$any(room.roomPlan)"
                  [canDelete]="true"
                  (delete)="clearRoomPlan()"></crm-file>
              </div>
            } @else {
              <div
                class="room-form-upload"
                role="button"
                tabindex="0"
                aria-label="Выбрать файл плана помещения"
                (click)="onUploadZoneClick($event, roomPlanUploader)"
                (keydown)="onUploadZoneKeydown($event, roomPlanUploader)">
                <i
                  class="pi pi-cloud-upload room-form-upload__icon-main"
                  aria-hidden="true"></i>
                <div class="room-form-upload__copy">
                  <span class="room-form-upload__title">Прикрепить план помещения</span>
                  <span class="room-form-upload__meta text-color-secondary">JPG, PNG, SVG - до 10 МБ</span>
                </div>
                <crm-file-uploader
                  #roomPlanUploader
                  class="room-form-upload__control"
                  label="Выбрать"
                  [accept]="roomAttachmentAccept"
                  [maxFileSize]="maxRoomAttachmentBytes"
                  styleClass="room-form-upload__btn"
                  (filesUploaded)="onRoomPlanFilesUploaded($event)"></crm-file-uploader>
              </div>
            }
            @if (errors?.roomPlan) {
              <small class="p-error">
                {{ errors.roomPlan | join }}
              </small>
            }
          </div>
          <div class="col-12 md:col-6 field room-form-plans-grid__cell">
            <label class="font-medium">Расположение на плане этажа</label>
            @if (room.floorPlan) {
              <div class="flex align-items-center gap-2 flex-wrap">
                <crm-file
                  [file]="$any(room.floorPlan)"
                  [canDelete]="true"
                  (delete)="clearFloorPlan()"></crm-file>
              </div>
            } @else {
              <div
                class="room-form-upload"
                role="button"
                tabindex="0"
                aria-label="Выбрать файл расположения на плане этажа"
                (click)="onUploadZoneClick($event, floorPlanUploader)"
                (keydown)="onUploadZoneKeydown($event, floorPlanUploader)">
                <i
                  class="pi pi-th-large room-form-upload__icon-main"
                  aria-hidden="true"></i>
                <div class="room-form-upload__copy">
                  <span class="room-form-upload__title">Прикрепить расположение на плане этажа</span>
                  <span class="room-form-upload__meta text-color-secondary">JPG, PNG, SVG - до 10 МБ</span>
                </div>
                <crm-file-uploader
                  #floorPlanUploader
                  class="room-form-upload__control"
                  label="Выбрать"
                  [accept]="roomAttachmentAccept"
                  [maxFileSize]="maxRoomAttachmentBytes"
                  styleClass="room-form-upload__btn"
                  (filesUploaded)="onFloorPlanFilesUploaded($event)"></crm-file-uploader>
              </div>
            }
            @if (errors?.floorPlan) {
              <small class="p-error">
                {{ errors.floorPlan | join }}
              </small>
            }
          </div>
        </div>
      </section>
      </div>

      @if (formState.canWrite) {
      <div class="room-form-footer">
        <span class="room-form-footer__hint">
          <span
            class="room-form-footer__asterisk"
            aria-hidden="true">*</span>
          <span class="room-form-footer__hint-text"> — обязательные поля</span>
        </span>
        <div class="room-form-footer__actions">
          @if (formState.isShowDelete) {
            <crm-button
              label="Удалить"
              styleClass="p-button-danger p-button-text"
              (onClick)="deleteRoom()"></crm-button>
          }
          <crm-button
            [label]="saveButtonLabel"
            styleClass="p-button-success"
            (onClick)="saveRoom()"></crm-button>
        </div>
      </div>
      }
    </div>
  }
} @else {
  <crm-spinner></crm-spinner>
}
